import { defaultStockData, StockDto } from "src/dtos/stock/stockDto";
import {
	defaultWmsTransportHeaderDto,
	WmsTransportHeaderDto,
} from "src/dtos/wmsTransport/wmsTransportDto";

/**
 * PUR5020_R01 - 재고수불장 재고 현황/원장 관리 DTO
 */
/**
 * 재고수불장 재고 현황 테이블 DTO (메인 테이블)
 */
export interface PUR5020_R01HeaderDto extends StockDto {
	compCd: string;
	compNm: string;
	locationCd?: string;
	locationNm?: string;
	currentQty: number;
	itemCost: number;
	stockAmount: number;
}

export const defaultPUR5020_R01HeaderDto: PUR5020_R01HeaderDto = {
	...defaultStockData,
	compCd: '',
	compNm: '',
	locationCd: '',
	locationNm: '',
	currentQty: 0,
	itemCost: 0,
	stockAmount: 0,
};

/**
 * 재고수불장 수불 이력(상세) 테이블 DTO (우측 상세 테이블)
 */
export interface PUR5020_R01DetailDto extends WmsTransportHeaderDto {
	txDt: string;
	partnerCd: string;
	partnerNm: string;
	inQty: number;
	outQty: number;
	balanceQty: number;
	txDtDisplay: string;
}

export const defaultPUR5020_R01DetailDto: PUR5020_R01DetailDto = {
	...defaultWmsTransportHeaderDto,
	txDt: '',
	partnerCd: '',
	partnerNm: '',
	inQty: 0,
	outQty: 0,
	balanceQty: 0,
	txDtDisplay: '',
};
